<template>
  <div class="row c-div-total">
    <div class="col-sm-12 text-right">
      <span class="c-title">
        Total de
        <div class="badge">
          <span class="total-records">{{ totalRecords }}</span>
        </div>
        <span class="records">registro(s)</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableTotalRecords",
  props: {
    totalRecords: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.c-div-total {
  padding-bottom: 10px;
}

.c-title {
  font-size: 14px;
}

.total-records {
  font-size: 16px;
  font-weight: 600;
}

.records {
  margin-left: 5px;
}
</style>
